import type { ConfigData } from '@/types'

export function readConfig(): ConfigData {
  const configElement = document.getElementById('sppd-gmr-config')
  let gmrConfig: ConfigData = { infoText: '', tableTitle: '' }

  if (configElement?.textContent) {
    try {
      const parsed = JSON.parse(configElement.textContent) as Partial<ConfigData>
      gmrConfig = {
        infoText: typeof parsed.infoText === 'string' ? parsed.infoText : '',
        tableTitle: typeof parsed.tableTitle === 'string' ? parsed.tableTitle : '',
      }
    } catch (error) {
      console.error('SPPD GMR: invalid config JSON', error)
    }
  }

  return gmrConfig
}
